import { Star } from "lucide-react";
import { Reveal, Tag, Heading } from "./Reveal";

const TESTIMONIALS = [
  {
    quote: "Our kitchen went from dark 1990s oak to a bright, airy space in four days. The crew protected everything, cleaned up every single night, and the final number matched the quote.",
    author: "Elena & Marc R.",
    detail: "Cabinet replacement · 4 days",
  },
  {
    quote: "I honestly didn't believe we could get new cabinets installed for anywhere near $5K. They walked us through exactly what was possible, and now the kitchen is my favorite room in the house.",
    author: "David S.",
    detail: "Cabinets & hardware · 3 days",
  },
  {
    quote: "New cabinets plus a herringbone backsplash, and the whole downstairs feels like a different home. The detail work — the trim, the alignment — is what sold us. They notice everything.",
    author: "Sarah L.",
    detail: "Cabinets & backsplash · 5 days",
  },
];

export const Testimonials = () => (
  <section className="py-24 lg:py-40" data-testid="testimonials-section">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
      <Reveal className="max-w-3xl">
        <Tag>Kitchen makeovers, in their words</Tag>
        <Heading className="mt-6">Homeowners who took the leap.</Heading>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 border-t border-ink/15">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.author} delay={i * 0.1} className="border-b md:border-b-0 md:border-r border-ink/15 md:last:border-r-0">
            <figure className="h-full flex flex-col pt-8 pb-10 md:pr-8 md:[&:not(:first-child)]:pl-8" data-testid={`testimonial-${i}`}>
              <div className="flex gap-1 text-teal" aria-label="5 out of 5 stars">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-3.5 w-3.5 fill-current" />
                ))}
              </div>
              <blockquote className="mt-8 font-display font-medium text-xl sm:text-2xl tracking-[-0.015em] leading-[1.25] text-ink flex-1">
                {t.quote}
              </blockquote>
              <figcaption className="mt-10">
                <p className="font-sans font-semibold text-sm text-ink">{t.author}</p>
                <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.14em] text-ink/50">{t.detail}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
